import { GLBApi } from "../api/3d/GLBApi/GLBApi";
import { IDataGLBRenderObject } from "../api/3d/GLBApi/type";
import { StatusName } from "../api/type";
import { IGLBData } from "./type";

export class GLBService {
  private glbApi: GLBApi = new GLBApi();

  public async renderGLB(data: IDataGLBRenderObject) {
    const response = await this.glbApi.renderGLB(data);
    return response.data;
  }

  public async getGLBData(data: IDataGLBRenderObject): Promise<IGLBData> {
    const response = await this.renderGLB(data);

    // Handle "already in queue" response
    if (response.message && response.message.includes('already in queue')) {
      return {
        hash: response.configHash || undefined,
        status: StatusName.PENDING,
      };
    }

    if (response.status === StatusName.SUCCESS) {
      return {
        url: response.glbUrl,
        status: response.status,
      };
    }

    return {
      hash: response.configHash,
      status: response.status || StatusName.PENDING,
    };
  }
}
